export default __webpack_public_path__ + "static/media/coding.1ab3085a.png";